<h1 mat-dialog-title>
  <div [style.font-size.px]="media.isActive('lt-sm') ? '16' : ''">
    {{ 'LABEL_FILTER' | translate }}
  </div>
</h1>

<div mat-dialog-content fxLayout="column" fxAlign="center center">
  <div fxLayout="column" fxLayoutGap="20px">

    <form [formGroup]="formGroup" novalidate autocomplete="off" autocorrect="off">
      <!-- chain -->
      <div>
        <mat-form-field class="width-100">
          <input 
            matInput
            required
            #chainInput
            formControlName="chain" 
            [matAutocomplete]="chainAC"
            [placeholder]="'LABEL_CHAIN' | translate" 
            (focus)="!chainAC.isOpen && getInitialData('chain')"
            >
      
          <mat-icon 
            matSuffix 
            color="primary"
            class="clear-input"
            svgIcon="close-circle"
            *ngIf="chainInput.value"
            (click)="resetControl(formGroup.get('chain')); chainInput.value = ''"
            >
          </mat-icon>
      
          <mat-icon 
            matSuffix 
            class="clear-input"
            svgIcon="menu-down"
            *ngIf="!chainInput.value"
            >
          </mat-icon>
      
          <mat-autocomplete 
            [displayWith]="displayFn"
            #chainAC="matAutocomplete" 
            (closed)="chainInput.blur()"
            (opened)="autocompleteScroll('chain','chainACRef','chainACTr')"
            >
            <mat-option
              disabled
              *ngIf="!loading.chain && chains?.length == 0"
              >
              {{ 'MSG_NO_DATA' | translate }}
            </mat-option>
      
            <mat-option *ngFor="let item of chains" [value]="item">
              {{ item.code != 'all' ? (item.code + ' - ') : '' }} {{ item.description }}
            </mat-option>
      
            <mat-option *ngIf="loading.chain" disabled>
              <mat-spinner color="primary" class="spinner-margin-auto" [diameter]="45"></mat-spinner>
            </mat-option>
          </mat-autocomplete>
      
          <mat-error *ngIf="formGroup.controls['chain'].hasError('required')">
            {{ 'MSG_FIELD_REQUIRED' | translate }}
          </mat-error>   

          <mat-error *ngIf="formGroup.controls['chain'].hasError('notExisting')">
              {{ 'MSG_DOESNT_EXIST' | translate: {type: ('LABEL_CHAIN' | translate)} }}
          </mat-error>
        </mat-form-field>
      </div>

      <!-- branch -->
      <div>
        <mat-form-field class="width-100">
          <input 
            matInput
            #branchInput
            formControlName="branch" 
            [matAutocomplete]="branchAC"
            [placeholder]="'LABEL_BRANCH' | translate" 
            (focus)="!branchAC.isOpen && getInitialData('branch')"
            >
      
          <mat-icon 
            matSuffix 
            color="primary"
            class="clear-input"
            svgIcon="close-circle"
            *ngIf="branchInput.value"
            (click)="resetControl(formGroup.get('branch')); branchInput.value = ''"
            >
          </mat-icon>
      
          <mat-icon 
            matSuffix 
            class="clear-input"
            svgIcon="menu-down"
            *ngIf="!branchInput.value"
            >
          </mat-icon>
      
          <mat-autocomplete 
            [displayWith]="displayFn"
            #branchAC="matAutocomplete" 
            (closed)="branchInput.blur()"
            (opened)="autocompleteScroll('branch','branchACRef','branchACTr')"
            >
            <mat-option
              disabled
              *ngIf="!loading.branch && branches?.length == 0"
              >
              {{ 'MSG_NO_DATA' | translate }}
            </mat-option>
      
            <mat-option *ngFor="let item of branches" [value]="item">
              {{ item.code != 'all' ? (item.code + ' - ') : '' }} {{ item.description }}
            </mat-option>
      
            <mat-option *ngIf="loading.branch" disabled>
              <mat-spinner color="primary" class="spinner-margin-auto" [diameter]="45"></mat-spinner>
            </mat-option>
          </mat-autocomplete>
      
          <mat-error *ngIf="formGroup.controls['branch'].hasError('notExisting')">
              {{ 'MSG_DOESNT_EXIST' | translate: {type: ('LABEL_BRANCH' | translate)} }}
          </mat-error>
        </mat-form-field>
      </div>

      <!-- category -->
      <div>
        <mat-form-field class="width-100">
          <input 
            matInput
            #categoryInput
            formControlName="category" 
            [matAutocomplete]="categoryAC"
            [placeholder]="'LABEL_CATEGORY' | translate" 
            (focus)="!categoryAC.isOpen && getInitialData('category')"
            >
      
          <mat-icon 
            matSuffix 
            color="primary"
            class="clear-input"
            svgIcon="close-circle"
            *ngIf="categoryInput.value"
            (click)="resetControl(formGroup.get('category')); categoryInput.value = ''"
            >
          </mat-icon>
      
          <mat-icon 
            matSuffix 
            class="clear-input"
            svgIcon="menu-down"
            *ngIf="!categoryInput.value"
            >
          </mat-icon>
      
          <mat-autocomplete 
            [displayWith]="displayFn"
            #categoryAC="matAutocomplete" 
            (closed)="categoryInput.blur()"
            (opened)="autocompleteScroll('category','categoryACRef','categoryACTr')"
            >
            <mat-option
              disabled
              *ngIf="!loading.category && categorys?.length == 0"
              >
              {{ 'MSG_NO_DATA' | translate }}
            </mat-option>
      
            <mat-option *ngFor="let item of categorys" [value]="item">
              {{ item.code != 'all' ? (item.code + ' - ') : '' }} {{ item.description }}
            </mat-option>
      
            <mat-option *ngIf="loading.category" disabled>
              <mat-spinner color="primary" class="spinner-margin-auto" [diameter]="45"></mat-spinner>
            </mat-option>
          </mat-autocomplete>
      
          <mat-error *ngIf="formGroup.controls['category'].hasError('notExisting')">
              {{ 'MSG_DOESNT_EXIST' | translate: {type: ('LABEL_CATEGORY' | translate)} }}
          </mat-error>
        </mat-form-field>
      </div>

      <!-- brand -->
      <div>
        <mat-form-field class="width-100">
          <input 
            matInput
            #brandInput
            formControlName="brand" 
            [matAutocomplete]="brandAC"
            [placeholder]="'LABEL_BRAND' | translate" 
            (focus)="!brandAC.isOpen && getInitialData('brand')"
            >
      
          <mat-icon 
            matSuffix 
            color="primary"
            class="clear-input"
            svgIcon="close-circle"
            *ngIf="brandInput.value"
            (click)="resetControl(formGroup.get('brand')); brandInput.value = ''"
            >
          </mat-icon>
      
          <mat-icon 
            matSuffix 
            class="clear-input"
            svgIcon="menu-down"
            *ngIf="!brandInput.value"
            >
          </mat-icon>
      
          <mat-autocomplete 
            [displayWith]="displayFn"
            #brandAC="matAutocomplete" 
            (closed)="brandInput.blur()"
            (opened)="autocompleteScroll('brand','brandACRef','brandACTr')"
            >
            <mat-option
              disabled
              *ngIf="!loading.brand && brands?.length == 0"
              >
              {{ 'MSG_NO_DATA' | translate }}
            </mat-option>
      
            <mat-option *ngFor="let item of brands" [value]="item">
              {{ item.code != 'all' ? (item.code + ' - ') : '' }} {{ item.description }}
            </mat-option>
      
            <mat-option *ngIf="loading.brand" disabled>
              <mat-spinner color="primary" class="spinner-margin-auto" [diameter]="45"></mat-spinner>
            </mat-option>
          </mat-autocomplete>
      
          <mat-error *ngIf="formGroup.controls['brand'].hasError('notExisting')">
              {{ 'MSG_DOESNT_EXIST' | translate: {type: ('LABEL_BRAND' | translate)} }}
          </mat-error>
        </mat-form-field>
      </div>

      <!-- item -->
      <div>
        <mat-form-field class="width-100">
          <input 
            matInput
            #itemInput
            formControlName="item" 
            [matAutocomplete]="itemAC"
            [placeholder]="'LABEL_ITEM' | translate" 
            (focus)="!itemAC.isOpen && getInitialData('item')"
            >
      
          <mat-icon 
            matSuffix 
            color="primary"
            class="clear-input"
            svgIcon="close-circle"
            *ngIf="itemInput.value"
            (click)="resetControl(formGroup.get('item')); itemInput.value = ''"
            >
          </mat-icon>
      
          <mat-icon 
            matSuffix 
            class="clear-input"
            svgIcon="menu-down"
            *ngIf="!itemInput.value"
            >
          </mat-icon>
      
          <mat-autocomplete 
            [displayWith]="displayFn"
            #itemAC="matAutocomplete" 
            (closed)="itemInput.blur()"
            (opened)="autocompleteScroll('item','itemACRef','itemACTr')"
            >
            <mat-option
              disabled
              *ngIf="!loading.item && items?.length == 0"
              >
              {{ 'MSG_NO_DATA' | translate }}
            </mat-option>
      
            <mat-option *ngFor="let item of items" [value]="item">
              {{ item.code != 'all' ? (item.code + ' - ') : '' }} {{ item.description }}
            </mat-option>
      
            <mat-option *ngIf="loading.item" disabled>
              <mat-spinner color="primary" class="spinner-margin-auto" [diameter]="45"></mat-spinner>
            </mat-option>
          </mat-autocomplete>
      
          <mat-error *ngIf="formGroup.controls['item'].hasError('notExisting')">
              {{ 'MSG_DOESNT_EXIST' | translate: {type: ('LABEL_ITEM' | translate)} }}
          </mat-error>
        </mat-form-field>
      </div>
      
      <!-- option -->
      <div>
        <mat-form-field>
          <mat-label>
            {{ 'LABEL_OPTION' | translate }}
          </mat-label>

          <mat-select formControlName="option" [compareWith]="compareWithFunc" required>
            <mat-option *ngFor="let opt of options" [value]="opt">
              {{ opt.description }}
            </mat-option>
          </mat-select>

          <mat-error *ngIf="formGroup.controls['option'].hasError('required')">
            {{ 'MSG_FIELD_REQUIRED' | translate }}
          </mat-error>    
        </mat-form-field>
      </div>

      <!-- dates -->
      <div fxLayout="column" fxLayoutGap="15px">
        <div fxFlex="50" fxLayout="column">
          <p class="sub-header">
            {{ 'LABEL_EFFECTIVITY_START_DATE' | translate }}
          </p>

          <div fxLayout fxLayoutGap="20px">
            <!-- from_effectivity_start_date -->
            <mat-form-field fxFlex="40">
              <input 
                readonly
                matInput 
                (click)="from_effectivity_start_date.open()" 
                [matDatepicker]="from_effectivity_start_date" 
                formControlName="from_effectivity_start_date" 
                [placeholder]="('LABEL_FROM' | translate)" 
                [required]="areDatesRequired('from_effectivity_end_date', 'to_effectivity_end_date')"
                >

              <mat-datepicker-toggle matSuffix [for]="from_effectivity_start_date"></mat-datepicker-toggle>
              <mat-datepicker #from_effectivity_start_date></mat-datepicker>

              <mat-error *ngIf="formGroup.get('from_effectivity_start_date').hasError('required')">
                {{ 'MSG_FIELD_REQUIRED' | translate }}
              </mat-error> 
            </mat-form-field>

            <!-- to_effectivity_start_date -->
            <mat-form-field fxFlex="40">
              <input 
                readonly
                matInput 
                (click)="to_effectivity_start_date.open()" 
                [matDatepicker]="to_effectivity_start_date" 
                formControlName="to_effectivity_start_date" 
                [placeholder]="('LABEL_TO' | translate)" 
                [min]="formGroup.get('from_effectivity_start_date').value || null" 
                [required]="areDatesRequired('from_effectivity_end_date', 'to_effectivity_end_date')"
                >
              
              <mat-datepicker-toggle matSuffix [for]="to_effectivity_start_date"></mat-datepicker-toggle>
              <mat-datepicker #to_effectivity_start_date></mat-datepicker>

              <mat-error *ngIf="formGroup.get('to_effectivity_start_date').hasError('required')">
                {{ 'MSG_FIELD_REQUIRED' | translate }}
              </mat-error> 
            </mat-form-field>

            <div fxFlex>
              <mat-icon 
                color="primary"
                class="clear-input"
                svgIcon="close-circle"
                (click)="clearDates('from_effectivity_start_date', 'to_effectivity_start_date')"
                >
              </mat-icon>
            </div>
          </div>
        </div>
        
        <!-- <mat-divider vertical="media.isActive('gt-sm')"></mat-divider> -->
        
        <div fxFlex="50" fxLayout="column">
          <p class="sub-header">
            {{ 'LABEL_EFFECTIVITY_END_DATE' | translate }}
          </p>

          <div fxLayout fxLayoutGap="20px">
            <!-- from_effectivity_end_date -->
            <mat-form-field fxFlex="40">
              <input 
                readonly
                matInput 
                (click)="from_effectivity_end_date.open()" 
                [matDatepicker]="from_effectivity_end_date" 
                formControlName="from_effectivity_end_date" 
                [placeholder]="('LABEL_FROM' | translate)" 
                [min]="formGroup.get('to_effectivity_start_date').value || formGroup.get('from_effectivity_start_date').value" 
                [required]="areDatesRequired('from_effectivity_start_date', 'to_effectivity_start_date')"
                >
      
              <mat-datepicker-toggle matSuffix [for]="from_effectivity_end_date"></mat-datepicker-toggle>
              <mat-datepicker #from_effectivity_end_date></mat-datepicker>
      
              <mat-error *ngIf="formGroup.get('from_effectivity_end_date').hasError('required')">
                {{ 'MSG_FIELD_REQUIRED' | translate }}
              </mat-error> 
            </mat-form-field>

            <!-- to_effectivity_end_date -->
            <mat-form-field fxFlex="40">
              <input 
                readonly
                matInput 
                (click)="to_effectivity_end_date.open()" 
                [matDatepicker]="to_effectivity_end_date" 
                formControlName="to_effectivity_end_date" 
                [placeholder]="('LABEL_TO' | translate)"  
                [min]="formGroup.get('from_effectivity_end_date').value || formGroup.get('to_effectivity_start_date').value || formGroup.get('from_effectivity_start_date').value" 
                [required]="areDatesRequired('from_effectivity_start_date', 'to_effectivity_start_date')"
                >
              
              <mat-datepicker-toggle matSuffix [for]="to_effectivity_end_date"></mat-datepicker-toggle>
              <mat-datepicker #to_effectivity_end_date></mat-datepicker>
      
              <mat-error *ngIf="formGroup.get('to_effectivity_end_date').hasError('required')">
                {{ 'MSG_FIELD_REQUIRED' | translate }}
              </mat-error> 
            </mat-form-field>

            <div fxFlex>
              <mat-icon 
                color="primary"
                class="clear-input"
                svgIcon="close-circle"
                (click)="clearDates('from_effectivity_end_date', 'to_effectivity_end_date')"
                >
              </mat-icon>
            </div>
          </div>
        </div>
      </div>

      <!-- Status -->
      <div>
        <mat-form-field class="form-field-filter">
          <mat-label>
            {{ 'LABEL_STATUS' | translate }}
          </mat-label>

          <mat-select formControlName="status" [compareWith]="compareWithFunc" required>
            <mat-option *ngFor="let opt of statuses" [value]="opt">
              {{opt.description}}
            </mat-option>
          </mat-select>

          <mat-error *ngIf="formGroup.controls['status'].hasError('required')">
            {{ 'MSG_FIELD_REQUIRED' | translate }}
          </mat-error> 
        </mat-form-field>
      </div>
    </form>

  </div>
</div>

<div mat-dialog-actions *ngIf="!media.isActive('lt-sm')" fxLayout fxLayoutAlign="end center">
  <button type="button" color="primary" mat-button (click)="applyFilters()"> {{ 'LABEL_APPLY' | translate }} </button>
  <button type="button" color="warn" mat-button (click)="reset()"> {{ 'LABEL_RESET' | translate }} </button>
  <button type="button" mat-button (click)="dialogRef.close()"> {{ 'LABEL_CANCEL' | translate }} </button>
</div>

<!-- buttons for mobile view -->
<div mat-dialog-actions *ngIf="media.isActive('lt-sm')" fxLayout fxLayoutAlign="end center">
  <button type="button" color="primary" mat-icon-button (click)="applyFilters()">
    <mat-icon svgIcon="check"></mat-icon>
  </button>

  <button type="button" color="warn" mat-icon-button (click)="reset()">
    <mat-icon svgIcon="restore"></mat-icon>
  </button>

  <button type="button" mat-icon-button (click)="dialogRef.close()">
    <mat-icon svgIcon="cancel"></mat-icon>
  </button>
</div>